
import { defineComponent, PropType, ref, watch } from "vue";
import MediaDisplay from "@/components/alerts/MediaDisplay.vue";
import {
  formatDateTime,
  formatDate,
} from "@/components/alerts/utils/alertFormatters";
import { GroupedAlert, TelegramMessageUI } from "@/stores/telegramAlerts";

export default defineComponent({
  name: "ManualLinkModal",
  components: {
    MediaDisplay,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    sourceMessage: {
      type: Object as PropType<TelegramMessageUI | null>,
      default: null,
    },
    targetAlerts: {
      type: Array as PropType<GroupedAlert[]>,
      default: () => [],
    },
    isLinking: {
      type: Boolean,
      default: false,
    },
    selectedMonth: {
      type: Number,
      required: true,
    },
    selectedYear: {
      type: Number,
      required: true,
    },
    months: {
      type: Array as PropType<string[]>,
      required: true,
    },
    years: {
      type: Array as PropType<number[]>,
      required: true,
    },
  },
  emits: [
    "close",
    "confirm-link",
    "update:selectedMonth",
    "update:selectedYear",
  ],
  setup(props, { emit }) {
    const selectedTargetAlertId = ref<number | null>(null);
    const selectedLinkType = ref<string | null>(null);

    const linkTypes = [
      { value: null, label: "Automático (Recomendado)" },
      { value: "odds_source", label: "Fuente de Cuotas (Merge)" },
      { value: "result", label: "Resultado" },
      { value: "supplementary", label: "Suplementario (Solo Relación)" },
    ];

    // Reset selection when modal closes or opens
    watch(
      () => props.show,
      (val) => {
        if (!val) {
          selectedTargetAlertId.value = null;
          selectedLinkType.value = null;
        }
      }
    );

    const confirm = () => {
      if (selectedTargetAlertId.value) {
        emit("confirm-link", {
          targetAlertId: selectedTargetAlertId.value,
          linkType: selectedLinkType.value,
        });
      }
    };

    return {
      selectedTargetAlertId,
      selectedLinkType,
      linkTypes,
      confirm,
      formatDateTime,
      formatDate,
    };
  },
});
